import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes,RouterModule } from '@angular/router';
 
import { AuthModule } from '../auth/auth.module';
import { AuthGuard } from './../pages/login/auth.guard';

const routes: Routes = [   
    {path: 'auth', loadChildren: '../auth/auth.module#AuthModule',canActivate:[AuthGuard]},
    
  //  {path: 'auth', loadChildren: '../auth/auth.module#AuthModule',},
    {path: 'login', loadChildren: '../pages/login/login.module#LoginModule'},
    
    {path: 'register', loadChildren: '../register/register.module#RegisterModule'},
    // {path: 'login', loadChildren: '../pages/login/login.module#LoginModule'},
    // {path: 'editor', loadChildren: '../editor/editor.module#EditorModule'},

     //{path: '**', redirectTo: 'auth/dashboard'},
    {path: '**', redirectTo: 'login'},

]


@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class LazyLoadModule { }
